module.exports = __webpack_public_path__ + "img/1.1a9e1afd.jpg";